import React, { useState, useEffect, useRef } from 'react';
import _ from 'underscore';
import { Panel } from 'react-bootstrap';
import { Table } from 'react-bootstrap';
import xtend from 'xtend';
import moment from 'moment';

import * as nodePath from 'path';


import MdCheck from 'react-icons/lib/md/check'
import MdRemoveCircle from 'react-icons/lib/md/remove-circle'

import Modal from '../../../common/components/Modal';
import Formatter from '../../../utils/Formatter';
import AssetImage from './AssetImage';
import Preview from '../../../events/components/event/Preview'
import ConfirmSubmitButton from '../../../common/components/ConfirmSubmitButton'
import RestrictedComponent from '../../../lib/components/form/RestrictedComponent';
import schema from '../../../routes/permissions/schema';
import ThumbnailModal from '../thumbnails/ThumbnailModal';

var noop = function () {};

/**
 * Styles for asset Metadata table
 */
const tdOverflowStyle = {
    overflowWrap: 'anywhere',
    maxWidth: '100px'
}

const anchorStyle = {
    display: 'block',
    maxHeight: '10em',
    overflow: 'auto'
}

// ThumbnailButton component
function ThumbnailButton (props) {
    var _props = xtend({
        type: "button",
        className: "fullheight",
        'data-toggle': "tooltip",
        'data-placement': "top",
        title: "Assign Thumbnail"
    }, props);
    return <div className="thumb-assign fullheight" style={{
        display: 'inline-block',
        float: 'right'
    }}>
        <button {..._props} className="btn btn-default">
            <i className="fa fa-camera" />
        </button>
    </div>;
}

const Asset = props => {
    const [deleteModal, setDeleteModal] = useState(false)
    const [editModal, setEditModal] = useState(false)
    const [edited, setEdited] = useState(false)
    const [edits, setEdits] = useState(null)
    const [deleting, setDeleting] = useState(false)
    const [preview, setPreview] = useState()
    const playerRef = useRef(null)
    const [isProcessingThumbnail, setIsProcessingThumbnail] = useState(false)
    const [thumbnailModalVisible, setThumbnailModalVisible] = useState(false)
    const [preSelectedAsset, setPreSelectedAsset] = useState(null)

    const toggleDeleteModal = () => {
      setDeleteModal(!deleteModal)
    }

    const toggleEditModal = () => {
        setEditModal(!editModal)
        setEdited(false)
        setEdits(null)
    }

    const handleThumbnailAssign = () => {
        props.getMiscAssets({});
        
        // If video preview is currently playing, capture the current time and asset info
        let currentAsset = null;
        
        if (preview && playerRef.current && props.asset.type === 'video') {
            try {
                const currentTime = playerRef.current.currentTime();
                
                // Create a mock asset object representing the current video with captured frame
                currentAsset = {
                    ...props.asset,
                    capturedFrame: {
                        url: null, // Will be set by the modal when it loads
                        timecode: currentTime
                    }
                };

                // pause the video
                playerRef.current.pause();
            } catch (error) {
                console.warn('Could not capture current video time:', error);
            }
        }
        
        setPreSelectedAsset(currentAsset);
        setThumbnailModalVisible(true);
        setPreview(false);
    }

    const handleCloseThumbnailModal = () => {
        setThumbnailModalVisible(false);
        setPreSelectedAsset(null);
    }

    const deleteAsset = (ev) => {
        ev && ev.preventDefault();

        function deleteResolved (err) {
            setDeleting(false)

            if (err) {
                return props.emitSnack({
                    type: 'error',
                    message: err.message
                });
            }

            props.emitSnack({
                type: 'success',
                message: 'Asset Deleted'
            });
        }

        setDeleting(true)

        if (props.mode == 'event') {
            props.actions.assets.delete({
                assetID: props.asset.assetID,
                eventID: props.event.eventID
            }, deleteResolved);
        } else {
            props.actions.delete({
                assetID: props.asset.assetID
            }, deleteResolved);
        }

        toggleDeleteModal()
    }

    const handleAssetChange = (field, value) => {
        setEdited(true)
        setEdits(prev => {
            if (prev === null) return {[field]: value}
            return {
                ...prev,
                [field]: value
            }
        })
    }

    const saveEdits = () => {
        toggleEditModal();

        function onResp (err, resp) {
            if (err) console.warn(err);
            props.emitSnack({
                type: 'success',
                message: 'Asset Updated'
            });
        }
        const domain = props.mode === 'event' ? props.actions.assets : props.actions
        let updateFunc
        let data = {...edits}

        if (props.asset.type === 'link') {
            const asset = props.asset
            updateFunc = domain.editLink
            data.eventID = asset.eventID
            data.linkName = data.linkName || asset.name
            data.linkURL = data.fileUrl || asset.fileUrl
            delete data.fileUrl
        } else {
            updateFunc = domain.edit
        }

        updateFunc({
            assetID: props.asset.assetID,
            ...data
        }, onResp)
    }

    const handlePublishAction = () => {
        let event = props.event
        let asset = props.asset

        let payload = {
            eventID: event.eventID,
            assetID: asset.assetID
        };

        if (event.eventStatus != 'published') {
            props.actions.publish(payload);
        } else {
            props.actions.unpublish(payload);
        }
    }

    const previewAsset = () => {
        switch (props.asset.type) {
            case 'video':
                if (preview){
                    setPreview(false)
                }else{
                    setPreview(true)
                }

                break;

            case 'image':
            case 'document':
                window.open(props.asset.fileUrl, '_blank');
                break;
        }
    }

    const getAssetThumb = () => {
        var thumb;

        switch (props.asset.type) {
        case 'video':
            thumb = props.asset.thumbnail;
            break;
        case 'image':
            thumb = props.asset.fileUrl;
            break;
        case 'link':
            thumb = props.asset.thumbnail;
            break;
        }

        try {
            if (thumb.indexOf('https') > -1) {
                thumb = thumb.split('https:')[1];
            } else if (thumb.indexOf('http') > -1) {
                thumb = thumb.split('http:')[1];
            }
        } catch (e) {
            // do nothing
        }

        // Removing timestamp to prevent unnecessary re-renders
        return thumb;
    }

    const getStatusText = () => {
        switch (props.asset.currentStatus.toLowerCase()) {
            case 'publishing': return 'Publishing';
            case 'transcode error': return 'Error';
            case 'available': return 'Available';
            case 'archive': return 'Archive';
            case 'transcoding': return 'Transcoding';
            case 'cue': return 'Cue';
            case 'processing live recording': return 'Processing Live Recording';
            case 'placeholder': return 'Pending';
            case 'processing upload': return 'Processing upload';
            case 'editing': return 'Processing edit...';
            default:
                console.warn('[Manage::Asset] Unhandled Asset Status - ', props.asset);
                return 'Waiting for Server...'
        }
    }

    const renderThumbnail = props => {
        var thumbnail = getAssetThumb();
        let previewSource = `https://svod.invintus.com/${props.asset.clientID}/${props.asset.assetID}/master.m3u8`
        if(props.asset.currentStatus === 'archive') {
            previewSource = `https://api.v3.invintusmedia.com/StreamURI/hls/${props.asset.clientID}/${props.asset.eventID}/media.m3u8`
        }

        if (preview) {
            const event = props.event
            const captionPath = event && event.captionPath
            return <div style={{height: '22vh', minHeight: '200px'}}>
                <Preview captionPath={captionPath} innerRef={playerRef} source={previewSource}/>
            </div>;
        }

        if (thumbnail && thumbnail !== '') {
            if (props.asset.currentStatus != 'TRANSCODE ERROR') {
                return <AssetImage thumbnail={thumbnail}/>;
            } else {
                return (
                    <div className="thumbnail icon-thumbnail">
                        <span className="alignment-helper"></span>
                        <i className="fa fa-exclamation-triangle"/>
                    </div>
                );
            }
        } else {
            var icon = <span/>;
            switch (props.asset.type) {
                case 'video':
                    icon = <i className="far fa-file-video"/>;
                    break;

                case 'image':
                    icon = <i className="far fa-file-image"/>;
                    break;

                case 'document':
                    icon = <i className="far fa-file-text"/>;
                    break;

                case 'audio':
                    icon = <i className="far fa-file-audio"/>;
                    break;

                case 'caption':
                    icon = <i className="far fa-closed-captioning"/>;
                    break;

                case 'placeholder':
                    icon = <i className="fa fa-refresh fa-spin fa-fw"/>;
                    break;
                case 'link':
                    icon = <i className='fa fa-link' />;
                    break;
                default:
                    console.warn('[Metadata::Asset] Unsupported Asset Type "%s"', props.asset.type);
                    break;
            }

            if (props.asset.currentStatus != 'transcoding') {
                return (
                    <div className="thumbnail icon-thumbnail">
                        <span className="alignment-helper"></span>
                        {icon}
                    </div>
                );
            }
        }
    }

    const renderMetadata = () => {
        let runtime;
        let progress = props.asset.transcodeProgress?.progress;
        let assetStatus = props.asset.currentStatus;
        let assetType = props.asset.type;
        let eventStatus = props.mode == 'event' ?
            props.event.eventStatus :
            null;

        let statusText = getStatusText();

        /**
         * @note
         * If the asset is transcoding, we need to ascertain whether
         * this assets's parent Event is Publishing Event, or conversely,
         * if this asset is just transcoding as part of the process that
         * comes post- Live or Upload processes.
         */
        if (progress !== undefined) {
            // console.log('eventStatus', eventStatus);
            // console.log('assetStatus', assetStatus);
            // console.log('assetType', assetType);
            // console.log('mode', props.mode);
            // console.log('deleting', deleting);
            if (eventStatus == 'publishing' && assetType == 'video') {
                // console.info('Mismatch? (eventStatus: %s, assetStatus: %s)', eventStatus, assetStatus)
                statusText = 'Publishing'
            }
        }

        if (assetType == 'video') {
            var temp = <em>Not Available</em>;

            try {
                temp = props.asset?.totalRunTime?.split('.')[0];
            } catch (e) {
                console.error(temp)
                // Do nothing as we have a fallback
                // should really be refactored :(
            }

            runtime = (
                <tr>
                    <td className="data-label">Runtime</td>
                    <td className="data-value">{temp}</td>
                </tr>
            );
        }

        /**
         * Progress bar if transcoding
         */
        if (props.asset.transcodeProgress?.progress) {
            progress = (
                <div className="progress" style={{marginTop: '1em'}}>
                    <div className="progress-bar progress-bar-striped active" role="progressbar" style={{minWidth: '2em', width: props.asset.transcodeProgress?.progress + '%'}}>
                        {props.asset.transcodeProgress?.progress}%
                    </div>
                </div>
            );
        }

        return (
            <div>
                {progress}

                <Table striped bordered condensed responsive>
                    <tbody>
                        <tr>
                            <td className="data-label">Status</td>
                            <td className="data-value">{statusText}</td>
                        </tr>
                        <tr>
                            <td className="data-label">Size</td>
                            <td className="data-value">{Formatter.bytesToSize(props.asset.fileSize)}</td>
                        </tr>
                        {assetType === 'link' ? <tr>
                            <td className="data-label">Location</td>
                            <td className="data-value" style={tdOverflowStyle}>
                                <a style={anchorStyle} href={props.asset.fileUrl} target="_blank" rel="noopener">
                                    {props.asset.fileUrl}
                                </a>
                            </td>
                        </tr> : null}

                        {runtime}
                    </tbody>
                </Table>
            </div>
        );
    }

    const renderPreviewActions = () => {
        let assetStatus = props.asset.currentStatus;
        let eventStatus = props.mode == 'event' ?
            props.event.eventStatus :
            null;

        let statusOk =
            assetStatus != 'transcoding' &&
            assetStatus != 'publishing' &&
            assetStatus != 'processing live recording' &&
            !deleting
        ;

        let showPreview = true;
        if (statusOk) {
            var viewAssetButtonIcon =
                (props.asset.type == 'video') ?
                    (preview) ?
                        <i className="fa fa-stop"/> : <i className="fa fa-play"/> :
                <i className="fa fa-search-plus"/>;

            if (props.asset.type === 'caption') {
                showPreview = false;
            }

            if (props.mode == 'event') {
                if (
                    assetStatus == 'transcode error' ||
                    assetStatus == 'cue' ||
                    assetStatus == 'transcoding' ||
                    eventStatus == 'publishing' ||
                    eventStatus == 'unpublishing' ||
                    eventStatus == 'editing'
                ) {
                    showPreview = false;
                }
            } else if (
                assetStatus == 'transcode error' ||
                assetStatus == 'cue' ||
                assetStatus == 'transcoding'
            ) {
                showPreview = false;
            }

            switch (props.mode) {

                case 'event':
                    return (
                        <div className="asset-actions">

                            {(showPreview) ?
                                <button style={props.asset.type === 'video' ? {
                                    maxWidth: '80%',
                                    display: 'inline-block'
                                } : props.asset.type === 'image' ? {
                                    maxWidth: '100%',
                                    display: 'inline-block'
                                } : {}}
                                    className="btn btn-default"
                                    onClick={previewAsset}
                                >
                                    {viewAssetButtonIcon} {(preview == true && props.asset.type === 'video') ? 'Close video preview' : 'Preview'}
                                </button> :
                                <span/>
                            }

                            {(props.asset.type === 'video' &&
                                props.mode === 'event' && showPreview) ?
                                <RestrictedComponent permissionCheck={schema.EVENT_TAB_ASSETS.ASSET_SET_THUMBNAIL}>
                                    <ThumbnailButton
                                        onClick={handleThumbnailAssign}
                                        isProcessing={isProcessingThumbnail}
                                    />
                                </RestrictedComponent> :
                                null
                            }
                        </div>
                    );
                case 'manage':
                    return (
                        <div className="asset-actions">
                            {(showPreview) ? <button className="btn btn-default" onClick={previewAsset}>{viewAssetButtonIcon} {(preview == true && props.asset.type === 'video') ? 'Close video preview' : 'Preview'}</button> : <span/>}
                        </div>
                    );
            }
        } else {
            return <span/>;
        }
    }

    const renderActions = () => {
        var status = props.asset.currentStatus;

        var statusOk =
            status != 'transcoding' &&
            status != 'publishing' &&
            status != 'processing live recording' &&
            !deleting
        ;

        if (statusOk) {
            var deleteAssetButton = <button
                className="btn btn-default"
                disabled={props.asset.pendingDelete}
                onClick={toggleDeleteModal}
            >
                <i className="fa fa-trash-can"/> Delete
            </button>;
            var showDeleteButton = false;

            let publishButtonProperties = {
                verb: "Publish",
                icon: <MdCheck/>,
                className: "btn btn-default",
                disabled: props.disabled,
                handleSubmit: handlePublishAction
            }

            let unpublishButtonProperties = {
                verb: "Unpublish",
                icon: <MdRemoveCircle/>,
                className: "btn btn-default",
                disabled: props.disabled,
                handleSubmit: handlePublishAction
            }

            var publishAssetButton =
                <ConfirmSubmitButton {...publishButtonProperties}/>

            var unpublishAssetButton =
                <ConfirmSubmitButton {...unpublishButtonProperties}/>


            var showPublishButton = false;
            var publishButton;

            if (props.asset.type == 'video') {
                if (props.mode == 'event') {
                    switch (props.event.eventStatus) {
                        case 'available':
                        case 'new':
                            if (status == 'available') {
                                publishButton = publishAssetButton;
                                showPublishButton = true;
                                showDeleteButton = true;
                            }
                            break;

                        case 'published':
                            if (status == 'archive') {
                                publishButton = unpublishAssetButton;
                                showPublishButton = true;
                            } else {
                                showDeleteButton = true;
                            }
                            break;

                        case 'live':
                            if (status == 'available') {
                                showDeleteButton = true;
                            }
                            break;
                    }
                } else if (props.mode == 'manage') {
                    if (status == 'archive' || status == 'available') {
                        showDeleteButton = true;
                    }
                }
            } else {
                showDeleteButton = true;
            }

            var download;
            switch (props.mode) {
                case 'manage':
                    if (!!props.asset.fileUrl) {
                        download = (
                            <a className="btn btn-default" href={props.asset.fileUrl}>
                                <i className="fa fa-download"/> Download
                            </a>
                        );
                    }
                    break;

                case 'event':
                    if (!!props.asset.path) {
                        const asset = props.asset
                        const { currentStatus, type } = asset
                        let path = asset.path

                        const audioEnabled = (
                            type === 'video' &&
                            currentStatus === 'archive'
                        )

                        let audioPath
                        let dlText;
                        switch (type) {

                        case 'video':
                            dlText = 'Video Download';
                            path = `https://invintus-mediaworkflow.s3.amazonaws.com/${asset.clientID}/${asset.assetID}.mp4`
                            if (status === 'archive') {


                                // Old implementation
                                // path = `https://m-download.invintus.com/${asset.clientID}/${asset.assetID}.mp4`
                                // audioPath = `https://m-download.invintus.com/${asset.clientID}/${asset.assetID}_audio.mp3`


                                /**
                                 * nodePath.basename(asset.path)
                                 *
                                 * - [x] Trim File ext
                                 * - [x] Audio
                                 * - [x] Default to `asset.fileUrl` after to:
                                 *  - `https://f005.backblazeb2.com/file/invintus-client-media`
                                 *
                                 * ---
                                 *
                                 * @note
                                 * asset:
                                 *  // ...
                                 *  "fileUrl": "https://f005.backblazeb2.com/file/invintus-client-media/<clientID>/<assetID>.mp4",
                                 *
                                 * replace: https://f005.backblazeb2.com/file/invintus-client-media with https://m-download.invintus.com
                                 * - leave the rest of the URI alone
                                 * - there is deep archive media that is not always in the root of the clientID
                                 * - e.g. https://f005.backblazeb2.com/file/invintus-client-media/<assetID>.mp4
                                 *
                                 * so:
                                 * - https://f005.backblazeb2.com/file/invintus-client-media/<clientID>/<assetID>.mp4
                                 *
                                 * becomes:
                                 * - https://m-download.invintus.com/<clientID>/<assetID>.mp4
                                 * - https://m-download.invintus.com/<clientID>/<assetID>_audio.mp3
                                 */

                                try {
                                    const KNOWN_STORAGE_URL = 'https://f005.backblazeb2.com/file/invintus-client-media'
                                    const storageIndex = asset.fileUrl.indexOf(KNOWN_STORAGE_URL);
                                    if (!!asset.fileUrl && storageIndex >= 0) {
                                        // trim out preceding slash
                                        let remainingUrl = asset.fileUrl.slice(KNOWN_STORAGE_URL.length + 1, asset.fileUrl.length)
                                        let trimmedUrlForAudio = remainingUrl.split('.mp4')[0]
                                        // let trimmedUrlForAudio = remainingUrl.substring(0, remainingUrl.length - 4)
                                        path = `https://m-download.invintus.com/${remainingUrl}`
                                        audioPath = `https://m-download.invintus.com/${trimmedUrlForAudio}_audio.mp3`
                                    }
                                } catch (error) {
                                    /**
                                     * The new implementation is hyper-specific about the content of the archived
                                     * video's URL so this is just a fallback.
                                     */
                                    console.group('ARCHIVE MEDIA DOWNLOAD URL ERROR');
                                    console.info('asset', asset);
                                    console.info('error', error);
                                    console.groupEnd();

                                    path = `https://m-download.invintus.com/${asset.clientID}/${nodePath.basename(asset.path)}`
                                    audioPath = `https://m-download.invintus.com/${asset.clientID}/${nodePath.basename(asset.path, '.mp4')}_audio.mp3`
                                }
                            }
                            break;

                        case 'link':
                            dlText = 'Open Link';
                            break;
                        case 'caption':
                            path = `https://m-download.invintus.com/${asset.clientID}/${asset.assetID}.vtt`
                            dlText = 'Download';
                            break;

                        default:
                            dlText = 'Download';
                        }

                        // const audioPath = (audioEnabled) ?
                        //     path.substring(0, path.length - 4) + '_audio.mp3' :
                        //     null

                        download = (
                            <RestrictedComponent permissionCheck={schema.EVENT_TAB_ASSETS.ASSET_DOWNLOAD}>
                                <div className="btn-group" style={{width: '100%'}}>
                                    <a
                                        style={{
                                            width: ((audioEnabled) ? '50%' : '100%'),
                                            overflow: 'hidden',
                                            textOverflow:'ellipsis'
                                        }}
                                        className="btn btn-default"
                                        href={path}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                    >
                                        <i className="fa fa-download"/> {dlText}
                                    </a>
                                    {audioEnabled ? <a
                                            style={{
                                                width: '50%',
                                                overflow: 'hidden',
                                                textOverflow: 'ellipsis'
                                            }}
                                            className="btn btn-default"
                                            href={audioPath}
                                            target="_blank"
                                            rel="noopener noreferrer"
                                        >
                                            <i className="fas fa-file-audio" /> Audio Download
                                        </a> : null
                                    }
                                </div>
                            </RestrictedComponent>

                        );
                    }
                    break;
            }

            switch (props.mode) {

                case 'event':
                    return (
                        <div className="asset-actions">


                            <RestrictedComponent permissionCheck={schema.EVENT_TAB_ASSETS.UPDATE}>
                                <button
                                    className="btn btn-default"
                                    onClick={toggleEditModal}>
                                    <i className="fa fa-pencil"/> Edit &amp; View Metadata
                                </button>
                            </RestrictedComponent>

                            {(showPublishButton) ? <RestrictedComponent permissionCheck={schema.EVENT_TAB_ASSETS.ASSET_PUBLISHING}>
                                    {publishButton}
                                </RestrictedComponent> : <span/>}
                            {(showDeleteButton) ? <RestrictedComponent permissionCheck={schema.EVENT_TAB_ASSETS.DELETE}>
                                {deleteAssetButton}
                            </RestrictedComponent> : null}
                            {download}
                        </div>
                    );

                case 'manage':
                    return (
                        <div className="asset-actions">
                            <button className="btn btn-default" onClick={toggleEditModal}><i className="fa fa-pencil"/> Edit &amp; View Metadata</button>
                            {(showDeleteButton) ? deleteAssetButton : null}
                            {download}
                        </div>
                    );

                case 'assign-fallback':
                    return (
                        <div className="asset-actions">
                            <button className="btn btn-default" onClick={props.assignAssetAsFallback.bind(null, props.asset)}><i className="fa fa-arrow-circle-down"/> Assign</button>
                        </div>
                    );

                case 'assign-slates':
                    var slatesAction;
                    var isAssigned = false;
                    var assigned = props.assigned;
                    var slatesMode = props.slatesMode;

                    if (assigned && assigned.length) {
                        for (var i = 0; i < assigned.length; i++) {
                            if (assigned[i].assetID == props.asset.assetID) {
                                isAssigned = true; break;
                            }
                        }
                    }

                    var btnClassName = isAssigned ? 'btn btn-success' : 'btn btn-default';
                    var icon = !isAssigned ?
                        <span><i className="fa fa-plus"/> Assign</span> :
                        <span><i className="fa fa-minus"/> Remove</span>;

                    if (slatesMode == 'video' || ((slatesMode == 'image' && isAssigned) || (slatesMode == 'image' && assigned.length === 0))) {
                        slatesAction = (<button className={btnClassName} onClick={props.assignSlate.bind(null, props.asset)}>
                            {icon}
                        </button>);
                    }

                    return (<div className="asset-actions">
                        {slatesAction || <span/>}
                    </div>);

                // Assign an asset to an event
                case 'assign':
                    return (
                        <div className="asset-actions">
                            <button className="btn btn-default" onClick={props.assignToEvent}>
                                <i className="fa fa-cloud-download"/> Assign
                            </button>
                        </div>
                    );

                case 'editor':
                    return (
                        <div className="asset-actions">
                            <button className="btn btn-default" onClick={props.addAssetToTimeline.bind(null, props.asset.assetID)}><i className="fa fa-plus"/></button>
                        </div>
                    );
            }
        } else {
            return <span/>;
        }
    }

    const renderModals = () => {
        var asset = props.asset;
        var now = moment();
        var assetTTL = moment(asset.TTL);
        var ttl = asset.TTL ? moment(assetTTL.diff(now)).format('D HH:mm:ss') : 'Not Currently Available';

        if (deleteModal) {
            return(<Modal
                cancelModal={toggleDeleteModal}
                saveAction={<button className="btn btn-danger" onClick={deleteAsset}>
                    <i className="fa fa-trash-can"/> Delete
                </button>}>
                <Modal.Header>
                    Delete Asset
                </Modal.Header>
                <Modal.Body>
                    <div className="alert alert-danger">
                        <h4>This Cannot Be Undone!</h4>
                        <p>Please confirm asset deletion.</p>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>);
        }

        if (editModal) {
            return (<Modal
                cancelModal={toggleEditModal}
                saveAction={<button className="btn btn-success" onClick={saveEdits}>
                    <i className="fa fa-save"/> Save
                </button>}>
                <Modal.Header>
                    Asset Metadata
                </Modal.Header>
                <Modal.Body>
                    <div>
                        <div>
                            <label>Asset Name</label>
                            <input className="form-control"
                                value={edited && (edits.name || edits.linkName) ?
                                    edits.name || edits.linkName :
                                    props.asset.name
                                }
                                onChange={e => handleAssetChange(props.asset.type === 'link' ? 'linkName' : 'name', e.target.value)}/>

                            {props.asset.type === 'link' ? <>
                            <label>Location</label>
                            <input className="form-control"
                                value={edited && edits.fileUrl ?
                                    edits.fileUrl :
                                    props.asset.fileUrl
                                }
                                onChange={e => handleAssetChange('fileUrl', e.target.value)}/>
                            </> : null}
                        </div>

                        <hr/>

                        <div className="callout">
                            <label>Asset Information</label>
                            <table className="table table-bordered table-striped table-condensed">
                                <tbody>
                                    <tr>
                                        <td><strong>Asset ID</strong></td>
                                        <td><span className="format-monospace">{asset.assetID}</span></td>
                                    </tr>
                                    <tr>
                                        <td><strong>Status</strong></td>
                                        <td>{asset.currentStatus}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Media Type</strong></td>
                                        <td>{asset.type}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Size</strong></td>
                                        <td>{asset.fileSize !== 0 ? Formatter.bytesToSize(asset.fileSize) : 'Could not Calculate'}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Shelf Life</strong></td>
                                        <td>{ttl}</td>
                                    </tr>
                                    <tr>
                                        <td><strong>Date Created</strong></td>
                                        <td>{asset.dateCreated}</td>
                                    </tr>

                                    <tr>
                                        <td><strong>Original filename</strong></td>
                                        <td>{getOriginalFilename(asset) ||
                                            <em>Not available</em>}</td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </Modal.Body>
                <Modal.Footer>
                </Modal.Footer>
            </Modal>)
        }

        if (thumbnailModalVisible) {
            return (
                <ThumbnailModal 
                    show={thumbnailModalVisible}
                    onClose={handleCloseThumbnailModal}
                    event={props.event}
                    emitSnack={props.emitSnack}
                    miscAssets={props.miscAssets?.data || []}
                    clientID={props.clientID}
                    targetAssetID={props.asset.assetID}
                    preSelectedAsset={preSelectedAsset}
                />
            );
        }
    }

    var view;
    switch (props.kind) {
        case 'existing':
        case 'miscellaneous':

            view = (
                <Panel>
                    <Panel.Body>
                        <label className="asset-name">
                            {props.asset.name}
                        </label>
                        {renderThumbnail(props)}
                        <span style={{padding: '1px'}} />
                        {renderPreviewActions()}
                        {renderMetadata()}
                        <hr/>
                        {renderActions()}
                    </Panel.Body>
                </Panel>
            );
            break;

        case 'upload':
            var p = props.asset.response?.percentComplete

            view = (
                <Panel>
                    <Panel.Body>
                        <label className="asset-name">{props.asset.uploadJson?.name}</label>
                        <div className="progress">
                            <div className="progress-bar progress-bar-striped active" role="progressbar" aria-valuenow={p} aria-valuemin="0" aria-valuemax="100" style={{width: p + '%', minWidth: '2em'}}>
                                {p}%
                            </div>
                        </div>
                        <div className="text-center">Uploading</div>
                    </Panel.Body>
                </Panel>
            );
            break;
    }

    var pending = props.asset.pendingDelete;
    var opacity = pending || deleting ? '0.4' : '1';
    return (
        <div style={{opacity: opacity}} className="col-xs-12 col-sm-6 col-md-4 col-lg-3">
            <div className={
                    'asset ' +
                    props.kind +
                    ' ' +
                    (
                        props.asset.type == 'video' &&
                        props.asset.currentStatus == 'archive' &&
                        (props.mode == 'event' ? props.event.eventStatus == 'published' : true) ?
                        'publishedAsset' : ''
                    )}>
                {view}
            </div>

            {renderModals()}
        </div>
    );
}

function getOriginalFilename (asset) {
    try {
        return asset.advancedDetails.general.filename
    } catch (err) {
        return undefined
    }
}

Asset.defaultProps = {
    onThumbnailAssign: noop
}

export default Asset;
